<script setup>
import { ref } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import PhoneSummaryReports from './components/PhoneSummaryReports.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summaryReportsRef = ref(null);

const onDownloadClick = () => {
  summaryReportsRef.value.downloadReports();
};
</script>

<template>
  <ReportHeader
    :header-title="$t('PHONE_REPORTS.HEADER')"
    :header-description="$t('PHONE_REPORTS.DESCRIPTION')"
  >
    <V4Button
      :label="$t('PHONE_REPORTS.DOWNLOAD_PHONE_REPORTS')"
      icon="i-ph-download-simple"
      size="sm"
      @click="onDownloadClick"
    />
  </ReportHeader>

  <PhoneSummaryReports
    ref="summaryReportsRef"
    action-key="summaryReports/fetchPhoneSummaryReports"
    summary-key="summaryReports/getPhoneSummaryReports"
    type="phone"
  />
</template>
